import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBxSidebar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 3H4C2.897 3 2 3.897 2 5V19C2 20.103 2.897 21 4 21H20C21.103 21 22 20.103 22 19V5C22 3.897 21.103 3 20 3ZM4 19V7H10V19H4ZM12 19V7H20V5L20.002 19H12Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 10H8V12H6V10ZM6 14H8V16H6V14Z",
		fill: "currentColor"
	})]
});
export default SvgBxSidebar;
